import {
  qx_eDeviceConnectionStatus_enum,
  qx_eDoorAlarm_enum,
  qx_eDoorState_enum,
  qx_ePACSStatus_enum
} from '@/graphql/types';
import {
  DEVICE_SIO_DEFAULT_ICON,
  DEVICE_DEFAULT_ICON_OFF,
  DEVICE_STATUS_COLORS,
  getDeviceStatusIcon
} from '@/constants/device';
import { getDoorStatusIcon } from '@/constants/door';
import { FaIconComplex } from '@/types';

export function getDeviceInventoryIcon(
  connectionStatus: qx_eDeviceConnectionStatus_enum | string,
  state: qx_eDoorState_enum,
  deviceMake?: string
): FaIconComplex {
  const connectionStatusIcon = getDeviceStatusIcon(
    true,
    connectionStatus,
    qx_ePACSStatus_enum.Unknown,
    qx_ePACSStatus_enum.Unknown,
    deviceMake
  );
  const stateIcon = getDoorStatusIcon(qx_eDoorAlarm_enum.Normal, state);

  if (
    connectionStatus !== qx_eDeviceConnectionStatus_enum.Connected &&
    connectionStatus !== qx_eDeviceConnectionStatus_enum.Online &&
    connectionStatusIcon
  ) {
    const showBothLabels = stateIcon.tooltip && connectionStatusIcon.tooltip;

    return {
      ...connectionStatusIcon,
      icon: DEVICE_SIO_DEFAULT_ICON,
      tooltip: `
        ${showBothLabels ? 'Connection: ' : ''}
        ${connectionStatusIcon.tooltip || ''}
        ${showBothLabels ? ' - ' : ''}
        ${showBothLabels ? `Last known state: ${stateIcon.tooltip}` : ''}
      `
    };
  }

  // Prefer connection for SIO inventory: accessInventory `state` is not always door-state shaped
  // (e.g. "Normal" hits getDoorStatusIcon's alarm-normal branch and returns grey).
  if (
    connectionStatus === qx_eDeviceConnectionStatus_enum.Connected ||
    connectionStatus === qx_eDeviceConnectionStatus_enum.Online
  ) {
    return {
      tooltip: connectionStatus,
      color: DEVICE_STATUS_COLORS.SUCCESS,
      iconStyle: 'fas',
      icon: DEVICE_SIO_DEFAULT_ICON
    };
  }

  if (state !== qx_eDoorState_enum.Unknown && stateIcon)
    return {
      ...stateIcon,
      icon: DEVICE_SIO_DEFAULT_ICON
    };

  return {
    tooltip: 'Unknown',
    color: DEVICE_STATUS_COLORS.GREY,
    iconStyle: 'fas',
    icon: DEVICE_DEFAULT_ICON_OFF,
    mask: 'triangle',
    transform: 'grow-2',
    opacity: '1',
    subColor: DEVICE_STATUS_COLORS.WARN,
    subIcon: 'question',
    subMask: 'triangle',
    subTransform: 'shrink-7 down-2',
    subStyle: {
      transform: 'scale(0.85) translateX(0.5px) !important'
    }
  };
}
